// import case names
import { get, find, cloneDeep, findIndex } from 'lodash';

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { resolveSecondaryOptionsResolver } from 'resolvers/resolveSecondaryOptions';
 */
export const resolveSecondaryOptionsResolver = ( { values, options, primaryTypeField, secondaryTypeField, fields } ) => {
   
    // get the primary option data
    const primaryOptionList = get( options, `${primaryTypeField.options}`, [] );
    const selectedValue = values[ primaryTypeField.name ];
    const primaryOption = find( primaryOptionList, { value: selectedValue } );

    // get the secondary field
    const secondaryFieldName = get( secondaryTypeField, 'name' );
    const secondaryFieldIndex = findIndex( fields, { name: secondaryFieldName } );
    const secondaryOptionKey = fields[ secondaryFieldIndex ].options;

    const secondaryOptions = get( primaryOption, 'options', [] );
    const updatedOptions = cloneDeep( options );
    updatedOptions[ secondaryOptionKey ] = secondaryOptions;

    return { updatedOptions };
};
